import { useTranslation } from 'react-i18next';

const CTASection = () => {
  const { t } = useTranslation('common');

  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-32 bg-stone-100">
      <div className="max-w-5xl mx-auto px-8 text-center">
        {/* Visual Area */}
        <div className="mb-12">
          <div className="w-full h-80 rounded-[2rem] overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/30ad348da43e4c44871b5dd850caf732.jpg"
              alt="Healing Space"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Text Content */}
        <div className="space-y-4 md:space-y-6 mb-8 md:mb-12">
          <h2 className="text-3xl md:text-5xl font-light text-gray-900 leading-tight">
            <span className="text-stone-400 italic">{t('cta.title')}</span>
            <br />
            <span className="font-medium">{t('cta.subtitle')}</span>
          </h2>
        </div>

        {/* CTA Button */}
        <button
          onClick={scrollToBooking}
          className="px-16 py-4 bg-teal-800 text-white rounded-full text-lg font-medium hover:bg-teal-900 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
        >
          {t('cta.button')}
        </button>
      </div>
    </section>
  );
};

export default CTASection;
